export default "__VITE_ASSET__f98c4f90__"